import * as React from "react";
import {
  Popover,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  ListSubheader,
  Divider,
  styled,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink } from "react-router-dom";

type AnchorEl = HTMLElement | null;

interface NavSection {
  title: string;
  items: { label: string; path: string }[];
}

const NAV_SECTIONS: NavSection[] = [
  {
    title: "Servicios",
    items: [
      { label: "Reparación de Celulares", path: "/reparacion-de-celulares" },
      { label: "Reparación de Computadores", path: "/reparacion-de-computadores" },
      { label: "Instalación de cámaras", path: "/instalacion-de-camaras-de-seguridad" },
      { label: "Educación", path: "/educacion" },
    ],
  },
  {
    title: "Diversión",
    items: [{ label: "Juegos", path: "/games" }],
  },
];

const navPaperSx = {
  mt: 1,
  minWidth: 280,
  borderRadius: 2,
  bgcolor: "text.primary",
  color: "common.white",
};

const SectionHeader = styled(ListSubheader)(({ theme }) => ({
  backgroundColor: theme.palette.text.secondary,
  color: theme.palette.text.primary,
  fontFamily: "Antonio, sans-serif",
  fontWeight: 700,
  fontSize: 12,
  lineHeight: "36px",
}));

const navItemSx = {
  px: 3,
  py: 1,
  "&:hover": { bgcolor: "action.hover" },
};

export default function NavBar() {
  const [anchorEl, setAnchorEl] = React.useState<AnchorEl>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? "navbar-popover" : undefined;

  return (
    <>
      <IconButton
        aria-describedby={id}
        aria-haspopup="menu"
        aria-label="Abrir menú de navegación"
        onClick={handleOpen}
        size="large"
        edge="start"
      >
        <MenuIcon />
      </IconButton>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            sx: navPaperSx,
          },
        }}
      >
        {NAV_SECTIONS.map((section, idx) => (
          <React.Fragment key={section.title}>
            {idx > 0 && <Divider sx={{ borderColor: "divider" }} />}
            <List
              dense
              disablePadding
              subheader={<SectionHeader>{`▾ ${section.title}`}</SectionHeader>}
            >
              {section.items.map((item) => (
                <ListItemButton
                  key={item.path}
                  component={RouterLink}
                  to={item.path}
                  onClick={handleClose}
                  sx={navItemSx}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      color: "common.white",
                      fontFamily: "Inter, sans-serif",
                      fontWeight: 400,
                      fontSize: 11,
                    }}
                  />
                </ListItemButton>
              ))}
            </List>
          </React.Fragment>
        ))}
      </Popover>
    </>
  );
}
